import {
  WhmSnackbar,
  useMediaQuery,
  Theme,
  WhmAlert,
  WhmTypography,
  whmTheme,
} from "@securitize/reactjs-whm";
import { useContext } from "react";
import { SnackbarContext } from "./SnackbarContext";

export interface SnackbarProps {
  isOpen: boolean;
  severity?: "error" | "warning" | "info" | "success";
  message?: React.ReactNode;
  onClose?: (event: React.SyntheticEvent<any> | Event, reason: string) => void;
  callback?: () => void;
}

const Snackbar: React.FC = () => {
  const {
    snackbarProps: { isOpen, severity, message, onClose },
  } = useContext(SnackbarContext);
  const isMobileOrTablet = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("xl"),
  );

  return (
    <WhmSnackbar
      open={isOpen}
      onClose={onClose}
      autoHideDuration={5000}
      anchorOrigin={{
        vertical: isMobileOrTablet ? "top" : "bottom",
        horizontal: "center",
      }}
    >
      <WhmAlert
        severity={severity}
        variant="filled"
        icon={false}
        sx={
          severity === "info"
            ? { backgroundColor: whmTheme.palette.secondary.main }
            : {}
        }
      >
        <WhmTypography component="div" sx={{ "& a": { color: "inherit" } }}>
          {message}
        </WhmTypography>
      </WhmAlert>
    </WhmSnackbar>
  );
};

export default Snackbar;
